import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import {
  AppAuthWrapper,
  LoginHandler,
  Reports43101AuthWrapper,
  ReportDetailAuthWrapper,
  ChatAuthWrapper,
} from "./Auth";

const app = document.getElementById("app");

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppAuthWrapper />,
  },
  {
    path: "/reports",
    element: <Reports43101AuthWrapper />,
  },
  {
    path: "/reports/:reportId",
    element: <ReportDetailAuthWrapper />,
  },
  {
    path: "/chat",
    element: <ChatAuthWrapper />,
  },
  {
    path: "/auth/",
    element: <LoginHandler />,
  },
]);

ReactDOM.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>,
  app
);
